/* istanbul ignore file */
import { array as codecArray } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { SiteSettingInput } from './SiteSettingInput';
const PatchSiteSettingsDataParser = 
/* #__PURE__ */ parsers.object([
    ['updates', /* #__PURE__ */ codecArray(SiteSettingInput)],
]);
export class PatchSiteSettingsData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchSiteSettingsDataParser.decode(input).map(res => new PatchSiteSettingsData(res));
    }
    static unsafeDecode(input) {
        return PatchSiteSettingsData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchSiteSettingsDataParser.encode(data);
    }
    static schema() {
        return PatchSiteSettingsDataParser.schema();
    }
}
